import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CompassIcon, GlobeIcon, LockIcon } from 'lucide-react';
import { regionalMarkets } from '../data/abbviePro';
const iconMap: Record<string, typeof LockIcon> = {
  Finland: LockIcon,
  Denmark: LockIcon,
  Sweden: GlobeIcon,
  'Nordic region': CompassIcon
};
export function RegionalCustomizationScreen() {
  const reduceMotion = useReducedMotion();
  return <section className="flex min-h-screen items-center bg-presentation-canvas px-6 py-20" aria-labelledby="regional-title" data-id="element-263" data-mp="1p4lvrr7zwtus">
      <div className="mx-auto w-full max-w-6xl" data-id="element-264" data-mp="1k2o4qatcsura">
        <p className="mb-4 text-sm font-semibold text-primary" data-id="element-265" data-mp="1ytx0l1nunccv">10 - Regional customisation</p>
        <h2 id="regional-title" className="max-w-2xl text-4xl font-bold leading-tight text-secondary md:text-6xl" data-id="element-266" data-mp="1u2f2qmh4hrw4">
          One model, market-specific rules
        </h2>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-267" data-mp="11e9ehpqv1krj">
          {regionalMarkets.map((market, index) => {
          const Icon = iconMap[market.market];
          return <motion.div key={market.market} initial={reduceMotion ? false : {
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.22,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="rounded-2xl border border-slate-200 bg-white p-5" data-id="element-268" data-mp="1qpmq7ym0hfzo" data-mpi={index}>
                <Icon className="h-5 w-5 text-abbvie-cyan" aria-hidden="true" data-id="element-269" data-mp="17qh3ot1myicz" />
                <h3 className="mt-4 font-bold text-abbvie-navy" data-id="element-270" data-mp="17slgk0hiirpe">{market.market}</h3>
                <p className="mt-1 text-xs font-bold uppercase tracking-wide text-abbvie-magenta" data-id="element-271" data-mp="1bugj18b6jb4r">{market.requirement}</p>
                <p className="mt-2 text-sm leading-relaxed text-slate-500" data-id="element-272" data-mp="2n7iz829d9yoe">{market.note}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}